'use client';

import React, { useEffect, useState, useRef } from 'react';
import { LayoutProps } from '@/types/generalSettings';
import BrokersAd = LayoutProps.BrokersAd;
import LogoAndNav from '@/components/layout/LogoAndNav';
import AuthButtons from '@/components/layout/AuthButtons';
import AdminTopbar from '@/components/layout/admin/AdminTopbar';
import { usePathname } from 'next/navigation';
import { ModeToggle } from '@/components/layout/ModeToggle';
import SearchModalComponent from '@/components/SearchModal';
import AppSidebarDrawer from '@/components/layout/AppSidebarDrawer';
import TetherAppBanner from '@/components/layout/TetherAppBanner';
import Search2LineIcon from 'remixicon-react/Search2LineIcon';
import { useSearchModalStore } from '@/stores/layout/searchModalStore';
// import TopPwaBanner from '@/components/layout/mobile/TopPwaBanner';

// Type definition for Header props
interface HeaderProps {
    // FIX: Allow extended menu items (with parentId) by using any or extending the type
    menuItems: any[];
    logo?: {
        sourceUrl?: string;
        mediaDetails?: {
            width?: number;
            height?: number;
        };
    };
    brokerAd?: BrokersAd[];
    exchangeForeignAd?: BrokersAd[];
    exchangeIranianAd?: BrokersAd[];
    propAd?: BrokersAd[];
    megaMenuContent?: any; // FIX: Added prop
}

const Header: React.FC<HeaderProps> = ({
    menuItems,
    logo,
    brokerAd,
    exchangeForeignAd,
    exchangeIranianAd,
    propAd,
    megaMenuContent,
}) => {
    const pathname = usePathname();

    const [isScrolledUp, setIsScrolledUp] = useState(false);
    const lastScrollTop = useRef(0); // a ref: scrolling must not re-render this component on every event
    const shouldDisplayTopBar = true;
    const [loading, setLoading] = useState(false);
    const openSearch = useSearchModalStore((state) => state.openSearch);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollTop = window.pageYOffset;
            if (currentScrollTop < lastScrollTop.current) {
                setIsScrolledUp(true);
            } else {
                setIsScrolledUp(false);
            }
            lastScrollTop.current = currentScrollTop <= 0 ? 0 : currentScrollTop;
        };

        if (shouldDisplayTopBar) {
            window.addEventListener('scroll', handleScroll, { passive: true });
        }

        return () => window.removeEventListener('scroll', handleScroll);
    }, [shouldDisplayTopBar]); // setIsScrolledUp re-renders only when the direction changes

    const hidePaths = [
        '/nokhbegan-test/',
        '/best-exchange-landing/',
        '/nokhbegan-54/',
        '/nokhbegan/',
        '/trade-webinar-24/',
        '/profile/dashboard/',
    ];

    if (hidePaths.includes(pathname)) return null;

    const scrollClass = isScrolledUp ? 'lg:top-[64px]' : 'lg:top-0 shadow-md';

    return (
        <>
            <AdminTopbar />
            <AppSidebarDrawer />
            <header
                className={`h-12 sticky top-0 flex items-center transition-all ease-in-out duration-500 ${scrollClass} z-50 bg-white dark:border-b dark:border-white/10 dark:bg-primary-dark`}
            >
                <div className='customContainer h-12 flex items-center justify-center max-xl:justify-between'>
                    {/* FIX: Pass megaMenuContent down */}
                    <LogoAndNav
                        setLoading={setLoading}
                        loading={loading}
                        menuItems={menuItems}
                        logo={logo}
                        brokerAd={brokerAd}
                        exchangeForeignAd={exchangeForeignAd}
                        exchangeIranianAd={exchangeIranianAd}
                        propAd={propAd}
                        megaMenuContent={megaMenuContent}
                    />
                    <div className='flex items-center gap-x-2 overflow-hidden w-fit'>
                        <ModeToggle className='w-fit max-xl:hidden' />
                        <SearchModalComponent setLoading={setLoading} className='max-xl:hidden' />
                        <AuthButtons className='max-xl:hidden' />
                        {/* Mobile: search (the modal itself is mounted once by SearchModalComponent above). */}
                        <button
                            type='button'
                            aria-label='جستجو'
                            onClick={() => openSearch()}
                            className='flex items-center justify-center size-8 rounded-full text-zinc-700 dark:text-white hover:text-progress dark:hover:text-progress transition-colors shrink-0 xl:hidden'
                        >
                            <Search2LineIcon size={20} />
                        </button>
                    </div>
                </div>
            </header>
            {/*<TopPwaBanner />*/}
            <TetherAppBanner />
        </>
    );
};

export default Header;
